module.exports = __webpack_public_path__ + "img/big-indent--success.93c41765.svg";